
import {TaskUpdate, TaskUpdateType} from "@/models/task.update";
import {basename} from "@/util/util";

/**
 *
 * @class TaskArtifactFetch
 *
 * track progress of fetching a Google Bucket stored artifact, for download or viewing etc.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2024
 *
 */
export class TaskArtifactFetch extends TaskUpdate {

  /** info to show to the user */
  public message: string;

  /** the icon to use */
  public icon:     string;

  /** the job being monitored */
  public artifact: string = '';

  /**
   * standard constructor, you have to uniquely identify the task progress stream (id)
   * and provide the type of progress update (type).
   *
   * @param id       the unique id of the task progress stream to clear (the context)
   * @param message  update text to show the user
   * @param progress estimate of progress
   * @param artifact the artifact we are fetching
   *
   */
  constructor(id: string, message: string, progress: number, artifact: string) {

    super(id, TaskUpdateType.Progress, progress);

    this.message  = message;
    this.icon     = '/assets/images/google-storage-32.png';
    this.artifact = artifact;
  }

  /** subclasses that can render their own update should return non-empty HTML */
  render(): string {

    let secondLine: string = basename(this.artifact);

    return `
<div class="task-file-upload-sub-panel">

  <div style="display: inline-block; width: 32px;">
    <img alt="creating model" class="tsp-icon" src="${this.icon}" width="32"></img>
  </div>

  <div style="display: inline-block; width: calc(100% - 40px); vertical-align: top; margin-top: 4px;">

    <div style="display: inline-block; ">
      <span class="tsp-label">${this.message}</span>
    </div>

    <div class="tsp-progress-border" style="margin-top: 6px; margin-bottom: 6px;">
      <div class="tsp-progress-bar" style="width: ${this.progress.toFixed(2)}%"></div>
    </div>

    <div style="display: inline-block; ">
      <span class="tsp-label">${secondLine}</span>
    </div>

  </div>

</div>
`;

  }


}
